import axios from "axios";

export default {
    getBookmarks: async (params) => {
        const { data } = await axios.get('/bookmarks/', {
            params
        })

        return data
    },
    putBookmark: async (id, body) => {
        const { data } = await axios.put(`/bookmarks/${id}`, body)
        return data
    },
    postBookmark: async (body) => {
        const { data } = await axios.post(`/bookmarks/`, body)
        return data
    },
    deleteBookmark: async (id) => {
        const { data } = await axios.delete(`/bookmarks/${id}`)
        return data
    },
}
